import React from 'react';

const LinkIcon = ({children}) => {
    const iconClass = children.toLowerCase()

    switch(iconClass){
        case "facebook":
            return <a href="https://www.facebook.com/delesslin" className="fa fa-facebook"></a>;
        case "twitter":
            return <a href="https://twitter.com/delesslin" className="fa fa-twitter"></a>
        default:
            return null;
    }
}

const Footer = () => {
    return ( 
        <footer>

            <div className="socials">
                <LinkIcon>facebook</LinkIcon>
                <LinkIcon>TWITTER</LinkIcon>
            </div>
        </footer>
     );
}
 
export default Footer;
